import { mapStores } from 'pinia'
import useBcStorageExplorerStore from '@/frontapp/store/bcStorageExplorer'

export default {
  emits: [
    'select',
    'unselect',
    'openDirectory',
  ],
  props: {
    item: {
      type: Object,
      default: null
    },
    isDataStorage: {
      type: Boolean,
      default: true
    },
    isSelected: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapStores(useBcStorageExplorerStore),
    previewImage() {
      if (this.isDataStorage) {
        return this.item.previews['500x500']
      }

      return this.item.previewUrl
    },
    isDirectory() {
      return !this.isDataStorage && this.item.type === 'dir'
    }
  },
  methods: {
    select(isShift) {
      if (isShift) {
        document.getSelection().empty()
      }

      if (!this.isSelected) {
        this.$emit(
          'select', 
          this.item, 
          {
            isShift,
            itemIndex: this.index,
          }
        )
      } else {
        this.$emit('unselect', this.item.id)
      }
    },
    handleItemClick(isShift) {
      document.getSelection().empty()

      if (this.isDirectory) {
        this.bcStorageExplorerStore.previousItemSelectedIndex === null
        this.$emit('openDirectory', this.item.id)
      } else {
        this.select(isShift)
      }
    }
  },
  mounted() {
    if (!this.isDirectory) {
      this.$refs.DocumentCircle.item = this.item
    }
  }
}
